<template>
  <modal :modal-key="'zero-balance-modal'"
         :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h1>

        <img class="usericon" src="static/images/oops.svg" alt="">

    </template>
    <template slot="body">
      {{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }}
    </template>
    <template slot="footer">
      <a v-if="!hideStore">
        <div class="btn2 btn2--std btn2--small btn2--fixed" style="cursor:pointer" @click.prevent="toBundlesPage">{{
          getTranslations.home_modals_zero_balance_unlock_games }}
        </div>
      </a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'zero-balance-modal',
  components: {
    Modal,
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForChallenge',
    ]),
    ...mapMutations('common', [
      'emptyActiveModalsStack',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.storeModalForChallenge(null);
      this.emptyActiveModalsStack();
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue